import { jsx as i, Fragment as g } from "react/jsx-runtime";
import { useMemo as m, Fragment as h } from "react";
const o = (t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), l = (t, e) => {
  const s = e.trim();
  if (!s)
    return [{ text: t, match: !1 }];
  const r = o(s), c = new RegExp(`(${r})`, "gi"), a = new RegExp(`^${r}$`, "i");
  return c.test(t) ? t.split(c).filter((n) => n !== "").map((n) => ({ text: n, match: a.test(n) })) : [{ text: t, match: !1 }];
}, p = (t, e) => m(() => l(t, e), [t, e]), x = ({ text: t, query: e }) => {
  const s = p(t, e);
  return /* @__PURE__ */ i(g, { children: s.map((r, c) => /* @__PURE__ */ i(h, { children: r.match ? /* @__PURE__ */ i("strong", { children: r.text }) : r.text }, c)) });
};
export {
  x as HighlightMatch,
  l as getHighlightMatchParts,
  p as useHighlightMatch
};
//# sourceMappingURL=highlight-match.es.js.map
